<div class="flex flex-col items-center justify-center gap-1 sm:mt-2 sm:gap-2">
    <div class="flex flex-row items-center justify-center gap-2 sm:gap-4">
        @if (headerInfo.useWhatsappIcon) {
            <app-whatsapp-icon iconClass="w-7 h-7 text-accent"></app-whatsapp-icon>
        } @else if (headerInfo.icon) {
            <fa-icon [icon]="headerInfo.icon" class="text-2xl text-accent"/>
        }
        <h1 class="text-xl font-bold text-primary sm:text-2xl">{{headerInfo.title | titlecase}}</h1>
    </div>

    @if (headerInfo.description) {
        <p class="hidden text-center text-sm text-secondary sm:block">{{headerInfo.description}}</p>
    }

</div>